import { GetterTree } from "vuex";
import { IReportState } from "@/store/modules/report/state";
import { DocumentReportListItem } from "@/types/report/ReportTypes";
import { IDataProvider, IRootState } from "@/store";

export enum ReportGetters {
  GET_ALL = "GET_ALL_REPORT",
  GET_CURRENT = "GET_CURRENT_REPORT",
  GET_DATA_PROVIDER = "GET_DATA_PROVIDER_REPORT",
}

export const getters: GetterTree<IReportState, IRootState> = {
  [ReportGetters.GET_ALL](state): DocumentReportListItem[] | null {
    return state.reports;
  },
  [ReportGetters.GET_CURRENT](state): DocumentReportListItem | null {
    return state.report;
  },
  [ReportGetters.GET_DATA_PROVIDER](
    state
  ): IDataProvider<DocumentReportListItem> | null {
    return state.dataProvider;
  },
};
